import { Component, OnInit, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { OrgService } from '../_services/org.service';
import { PhaseService } from '../_services/phase.service';
import { JwtHelperService } from '@auth0/angular-jwt';

interface SortableColumn {
	//duplicated interface, pull out of Progress-table and here
	visible?: boolean;
	selected: boolean;
	isAscending: boolean;
	selectedChallengeId?: number;
	label?: string;
}

@Component({
	selector: 'app-progress-table-accordion',
	templateUrl: './progress-table-accordion.component.html',
	styleUrls: ['./progress-table-accordion.component.css'],
})
export class ProgressAccordionComponent implements OnInit {
	subscriptions: Subscription[] = [];
	selectedSchool: any;
	phases: any;
	tableSort: any;
	currentSavedColumns: any;
	selectedClassroomNodeId: number;
	filterText: string = '';

	public defaultColumns = {
		lastNameColumn: <SortableColumn>{ visible: true, selected: true, isAscending: true, label: 'Last Name' },
		firstNameColumn: <SortableColumn>{ visible: true, selected: false, isAscending: false, label: 'First Name' },
		gradeColumn: <SortableColumn>{ visible: true, selected: false, isAscending: false, label: 'Grade' },
		timesAssessedColumn: <SortableColumn>{
			visible: true,
			selected: false,
			isAscending: false,
			label: 'Times Assessed',
		},
		dateAssessedColumn: <SortableColumn>{ visible: true, selected: false, isAscending: false, label: 'Last Assesment' },
		challengeIdColumn: <SortableColumn>{ selected: false, isAscending: false, selectedChallengeId: null },
		allChallengesColumn: <SortableColumn>{ selected: false, isAscending: false, label: 'Challenge Scores' },
	};

	@ViewChildren('accordionButton') accordionButtons: QueryList<ElementRef>;

	constructor(
		private orgService: OrgService,
		public phaseService: PhaseService,
		private jwtHelper: JwtHelperService
	) {}

	toggleAccordion(assessmentBookId) {
		this.accordionButtons.forEach((button) => {
			const dataBookId = button.nativeElement.getAttribute('data-book-id');
			const isExpanded = button.nativeElement.getAttribute('aria-expanded') === 'true';

			if (dataBookId === assessmentBookId && !isExpanded) {
				button.nativeElement.click();
			} else if (dataBookId !== assessmentBookId && isExpanded) {
				button.nativeElement.click();
			}
		});
	}

	ngOnInit(): void {
		this.subscriptions.push(
			this.phaseService.phases$.subscribe((data) => {
				this.phases = data;
			})
		);

		this.subscriptions.push(
			this.orgService.selectedClassroom$.subscribe((data) => {
				if (data && data.id) {
					this.selectedClassroomNodeId = data.id;
					//Setting currentSavedColumns here broadcasts it to the tables
					this.currentSavedColumns = this.getUserTableState();
				}
			})
		);
	}

	public recieveSortingBroadcast(sorting: any) {
		if (sorting != null) {
			this.currentSavedColumns = null;
			this.currentSavedColumns = { ...sorting };
			this.saveUserTableState();
		}
	}

	private saveUserTableState() {
		const userToken = localStorage.getItem('currentUser');
		try {
			const userID = this.jwtHelper.decodeToken(userToken).id;
			const existingSettings = JSON.parse(localStorage.getItem('userSettings')) || {};

			if (!existingSettings[userID]) {
				existingSettings[userID] = {};
			}

			if (!existingSettings[userID][this.selectedClassroomNodeId.toString()]) {
				existingSettings[userID][this.selectedClassroomNodeId.toString()] = {};
			}

			if (!existingSettings[userID][this.selectedClassroomNodeId.toString()]['progress table']) {
				existingSettings[userID][this.selectedClassroomNodeId.toString()]['progress table'] = {};
			}

			existingSettings[userID][this.selectedClassroomNodeId.toString()]['progress table'] = this.currentSavedColumns;

			// Save the updated settings back to localStorage
			localStorage.setItem('userSettings', JSON.stringify(existingSettings));

			console.log('User settings saved:', existingSettings);
		} catch (error) {
			console.error('Error decoding token, retrieving User ID, or saving user settings:', error);
		}
	}

	private getUserTableState(): any {
		const userToken = localStorage.getItem('currentUser');

		try {
			const userID = this.jwtHelper.decodeToken(userToken).id;
			const existingSettings = JSON.parse(localStorage.getItem('userSettings')) || {};

			//fetching user settings
			const tableSortObject = existingSettings[userID]?.[this.selectedClassroomNodeId]?.['progress table'] ?? null;

			return tableSortObject;
		} catch (error) {
			console.error('Error decoding token, retrieving User ID, or retrieving user settings:', error);
			return null;
		}
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
